module.exports = __webpack_public_path__ + "img/ljdk_zhCn.3ed46fcb.png";